<template>
  <form class="client-profile-form" @submit.prevent="handleNext">
    <section class="profile-form-section" aria-labelledby="profile-client-heading">
      <div class="profile-form-copy">
        <h2 id="profile-client-heading">Client details</h2>
        <p>Enter the client name and abbreviation.</p>
      </div>
      <div class="profile-form-fields">
        <div class="profile-form-field">
          <label for="client">Client name</label>
          <input type="text" id="client" v-model="client" />
        </div>
        <div class="profile-form-field">
          <label for="client-abbreviation">Client abbreviation</label>
          <input type="text" id="client-abbreviation" v-model="abbr" />
        </div>
      </div>
    </section>
    <section class="profile-form-section" aria-labelledby="profile-contact-heading">
      <div class="profile-form-copy">
        <h2 id="profile-contact-heading">Contact details</h2>
        <p>Provide the office address and contact information.</p>
      </div>
      <div class="profile-form-fields">
        <div class="profile-form-field profile-form-wide">
          <label for="address">Office address</label>
          <input type="text" id="address" v-model="address" />
        </div>
        <div class="profile-form-field">
          <label for="client-state">State</label>
          <select id="client-state" v-model="state">
            <option value="" disabled>Select state</option>
            <option v-for="(state, n) in allStates" :key="n">{{ state }}</option>
          </select>
        </div>
        <div class="profile-form-field">
          <label for="phone">Phone number</label>
          <input type="text" id="phone" v-model="phone" pattern="[0-9]{10,13}" class="validate" />
        </div>
        <div class="profile-form-field profile-form-wide">
          <label for="email">Email address</label>
          <div class="profile-email-control">
            <input type="email" id="email" v-model="email" class="validate" />
            <div class="progress" v-if="isChecking" aria-label="Checking email"><div class="indeterminate"></div></div>
          </div>
          <p class="profile-field-error" role="alert" v-if="email && !isChecking && checkedEmailCounter > 0">This email address is already in use.</p>
        </div>
      </div>
    </section>
    <section class="profile-form-section" aria-labelledby="profile-scheme-heading">
      <div class="profile-form-copy">
        <h2 id="profile-scheme-heading">Scheme</h2>
        <p>The scheme for this client account.</p>
      </div>
      <div class="profile-form-fields">
        <div class="profile-form-field profile-form-wide">
          <label for="client-scheme">Scheme</label>
          <input id="client-scheme" type="text" value="Private Scheme" readonly />
        </div>
      </div>
    </section>
    <div class="profile-form-actions">
      <button type="submit" class="btn" :disabled="isSubmitting || !client || !abbr || !address || !state || !email || checkedEmailCounter > 0 || !phone"
        :class="{ disabled: isSubmitting || !client || !abbr || !address || !state || !email || checkedEmailCounter > 0 || !phone }">
        <span>{{ isSubmitting ? 'Loading...' : 'Next' }}</span><i class="material-icons" aria-hidden="true">arrow_forward</i>
      </button>
    </div>
  </form>
</template>
<script>
import { ref, onMounted, onUpdated, watchEffect } from "vue";
import getItems from "@/composables/getItems";
// import postItem from "@/composables/postItem";
import nativeUi from "@/ui/native-ui";


export default {
  name: "ProfileOnboardComponent",
  emits: ["back", "next"],
  props: ["cat", "newClient"],
  setup(props, context) {
    const isSubmitting = ref(false);
    const isChecking = ref(false);
    const error = ref(null);
    const client = ref(null);
    const abbr = ref(null);
    const address = ref(null);
    const allStates = ref([]);
    const state = ref(null);
    const email = ref(null);
    const checkedEmailCounter = ref(1); // default to 1 to disable next button
    const phone = ref(null);

    // check for back
    onMounted(() => {
      if (props?.newClient?.profile) {
        // reload
        client.value = props?.newClient?.profile?.name;
        abbr.value = props?.newClient?.profile?.abbr;
        address.value = props?.newClient?.profile?.address;
        state.value = props?.newClient?.profile?.state;
        phone.value = props?.newClient?.profile?.phone;
        email.value = props?.newClient?.profile?.email;
      }
    });

     // select
    onUpdated(() => {
      // activate select field
      const elemsSelect = document.querySelectorAll("select");
      nativeUi.FormSelect.init(elemsSelect, {});
    });

     // select
    onMounted(() => {
      // activate select field
      const elemsSelect = document.querySelectorAll("select");
      nativeUi.FormSelect.init(elemsSelect, {});
    });

    // check for back
    onMounted(() => {
      // all states
      allStates.value = [
        "Abia",
        "Adamawa",
        "Akwa Ibom",
        "Anambra",
        "Bauchi",
        "Bayelsa",
        "Benue",
        "Borno",
        "Cross River",
        "Delta",
        "Ebonyi",
        "Edo",
        "Ekiti",
        "Enugu",
        "FCT",  // Federal Capital Territory
        "Gombe",
        "Imo",
        "Jigawa",
        "Kaduna",
        "Kano",
        "Katsina",
        "Kebbi",
        "Kogi",
        "Kwara",
        "Lagos",
        "Nasarawa",
        "Niger",
        "Ogun",
        "Ondo",
        "Osun",
        "Oyo",
        "Plateau",
        "Rivers",
        "Sokoto",
        "Taraba",
        "Yobe",
        "Zamfara"
      ];

    });

    // handle netxt
    const handleNext = async () => {
      if (client.value || abbr.value || address.value || state.value || email.value || phone.value) {

        // end submit hold
        isSubmitting.value = true;

        // round up
        const newVal = {
          scheme_id: null, // added on the server (looks for private scheme id)
          cat: props.cat,
          name: client.value,
          abbr: abbr.value,
          address: address.value,
          state: state.value,
          phone: phone.value,
          email: email.value,
        };

        // final load
        context.emit("next", {
          id: "profile",
          value: newVal,
        });


        // // post item
        // const { res, err } = await postItem("client", newVal);

        // if (res.value) {
        //   // success
        //   // emit new parameters
        //   context.emit("next", {
        //     id: "profile",
        //     value: res.value.data,
        //   });
        // } else {
        //   error.value = err.value;
        //   console.log(error.value);
        // }


      } else {
        error.value = "All fields not selected"; // most unlikely
      }
      // end submit hold
      isSubmitting.value = false;
    };

    // watch upload
    watchEffect(() => {
      // if (email.value?.includes('@') && email.value?.includes('.')) {

        // search email
        isChecking.value = true;

        // always set to default
        checkedEmailCounter.value = 1;

        // check email
        (async () => {
          const { res } = await getItems(`client/email/checker?email=${email.value}`);

          if (res.value) {
            // update conter
            checkedEmailCounter.value = res.value.data;
          }

          // end checking 
          isChecking.value = false;
        })();

      // }
    });

    return {
      isSubmitting,
      isChecking,
      handleNext,
      error,
      client,
      abbr,
      address,
      allStates,
      state,
      email,
      checkedEmailCounter,
      phone,
    };
  },
};
</script>

<style scoped>
.client-profile-form { max-width: 70rem; width: 100%; }
.profile-form-section { align-items: start; border-bottom: 1px solid var(--ui-border); display: grid; gap: 2.5rem; grid-template-columns: 13rem minmax(0, 1fr); padding: 1.75rem 0; }
.profile-form-section:first-child { padding-top: .5rem; }
.profile-form-copy h2 { color: var(--ui-foreground); font-size: 1rem; font-weight: 600; line-height: 1.5; margin: 0 0 .35rem; }
.profile-form-copy p { color: var(--ui-muted-foreground); font-size: .8125rem; line-height: 1.6; margin: 0; }
.profile-form-fields { display: grid; gap: 1.25rem; grid-template-columns: repeat(2, minmax(0, 1fr)); min-width: 0; }
.profile-form-field { min-width: 0; }
.profile-form-wide { grid-column: 1 / -1; }
.profile-form-field > label { color: var(--ui-foreground); display: block; font-size: .8125rem; font-weight: 500; line-height: 1.5; margin: 0 0 .5rem; }
.profile-form-field :is(input, select) { box-sizing: border-box; display: block; margin: 0; min-height: 2.75rem; width: 100%; }
.profile-email-control { position: relative; }
.profile-email-control .progress { bottom: 1px; height: 3px; left: 1px; margin: 0; position: absolute; right: 1px; }
.profile-field-error { color: var(--ui-destructive); font-size: .75rem; line-height: 1.5; margin: .5rem 0 0; }
.profile-form-actions { display: flex; justify-content: flex-end; padding-top: 1.25rem; }
.profile-form-actions button { font-size: .8125rem; font-weight: 600; gap: .5rem; }
.profile-form-actions i { font-size: 1rem; }
@media (max-width: 900px) {
  .profile-form-section { gap: 1rem; grid-template-columns: minmax(0, 1fr); }
}
@media (max-width: 600px) {
  .profile-form-fields { grid-template-columns: minmax(0, 1fr); }
}
</style>
